import PropTypes from 'prop-types';
import React from 'react';
import { getDimensionDots } from '../utilities/navigation';

class ProgressBar extends React.Component {
	constructor(props) {
		super(props);

		this.getDimensionDots = getDimensionDots.bind(this);
	}

	render() {
		const { progress, callback, resultsSlide } = this.props;
		return (
			progress && (
				<div className="ms-form__progress">
					<span className="progress__label">{'label' in progress && progress.label}</span>
					{!isNaN(progress.handle) && (
						<div className="progress__bar" style={{ '--progress': `${progress.handle}%` }}>
							<div className="progress__bar-dots">
								{this.getDimensionDots().map((dot) => dot)}
								<div key="success" className={`dot${progress.handle == 100 ? ' done' : ''}`} onClick={() => callback(resultsSlide)} />
							</div>

							<span className="progress__bar-handle" />
						</div>
					)}
				</div>
			)
		);
	}
}

export default ProgressBar;

ProgressBar.propTypes = {
	resultsSlide: PropTypes.number,
	dimensions: PropTypes.object,
	progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	callback: PropTypes.func,
};
